module.exports = __webpack_public_path__ + "static/media/6.e7247e53.svg";